const bkpostventa = {
  FORMS: [],
  CSS: {
    id: '633449c2270996a009650c55',
    name: 'bkpostventa',
    avatar: {
      name: 'BK PostVenta',
      header: 'https://chatbotqa.gatblac.com/static/avatar/bk/bkpostventa/avatar-reposo.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/bk/bkpostventa/avatar-inactivo.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/bk/bkpostventa/avatar-activo.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/bk/bkpostventa/avatar-reposo.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#00A9E3',
        borderColor: '#00A9E3'
      }
    }
  }
}

export default bkpostventa
